var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_setup.dialogStore.dialogs),function(dialog,index){return _c('dialog',{key:index,ref:(el) => {
        if (el) {
          _setup.dialogRefs[index] = el;
        }
      },refInFor:true},[_c('div',{staticClass:"flex justify-center flex-col gap-8 py-2 px-1 w-[80vw] max-w-[300px]"},[_c('span',{staticClass:"text-[1.1rem]"},[_vm._v(_vm._s(dialog.text))]),_c('div',{staticClass:"flex justify-center"},[_c('Button',{staticClass:"w-[90%] max-w-[230px]",attrs:{"label":"Close"},on:{"click":function($event){return _setup.closeDialog(index)}}})],1)])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }